<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  box-sizing: border-box;
  font-size: .3rem;
}
html, body, #app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue